module.exports = __webpack_public_path__ + "img/aws-logo.1f94eb2e.png";